import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/dashboard.module.css';
import downLoadIcon from '../../../assets/images/downLoadIcon.webp';
import infoIcon from '../../../assets/images/infoIcon.png';
import FeaturePoup from './FeaturePoup';

export default function DashboardPanel() {
    const { currentUser, logout } = useAuth();
    const navigate = useNavigate();
    const [statusData, setStatusData] = useState();
    const [dashboardData, setDashboardData] = useState();
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [togglePopup, setToggleOpup] = useState(false);
    const [toggleCancelAccountWindow, setToggleCancelAccountWindow] = useState(false);



    useEffect(() => {
        async function checkPaymentStatus() {
            const userId = localStorage.getItem('userId');
            if (userId) {
                const response = await fetch(process.env.REACT_APP_PUBLIC_PAYMENT_URL + "payment/status?userId=" + userId);
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                let data = await response.json();
                setStatusData(data);
                // console.log('pay status', data);
            }
        }
        async function getDashboard() {
            const userId = localStorage.getItem('userId');
            if (userId) {
                const response = await fetch(process.env.REACT_APP_PUBLIC_PAYMENT_URL + "payment/dashboard?userId=" + userId);
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                let data = await response.json();
                setDashboardData(data);
                // console.log('setDashboardData', data);
            }
        }
        checkPaymentStatus();
        getDashboard();
    }, []);



    async function handleLogout() {
        try {
            await logout();
            navigate('/');
        } catch (error) {
            console.error('Failed to log out:', error);
        }
    }

    async function handleCancelAccount() {

        try {
            const userId = localStorage.getItem('userId');
            if (userId) {
                // const userConfirmed = window.confirm('Are you sure you want to cancel your account?');

                const response = await fetch(process.env.REACT_APP_PUBLIC_PAYMENT_URL + "cancel/confirm", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ userId: userId }),
                });
                if (!response.ok) {
                    const data = await response.json();
                    if (data?.error) {
                        setError(data.error);
                    } else {
                        throw new Error('Failed to cancel account: ', data);
                    }
                } else {
                    setMessage('Your account has been cancelled.');
                }

            }
        } catch (error) {
            console.error('Failed to cancel account:', error);
        }
    }

    const toggleInfoPopup = () => {
        setToggleOpup(!togglePopup);
    }
    const showCancelPopup = () => {
        setToggleCancelAccountWindow(true);
    }
    const closeCancelWindow = () => {
        setToggleCancelAccountWindow(false);
        navigate(0);
    }

    return (
        <div>
            {toggleCancelAccountWindow &&
                <div className={styles.cancelPoup}>
                    {message === '' && error === '' ? <>
                        <p className={styles.cancelTitle}>Are you sure you want to cancel your account?</p>
                        <div className={styles.cancelButtonsContainer}>
                            <button className={styles.cancelButton} onClick={handleCancelAccount}>Yes</button>
                            <button className={styles.cancelButton} onClick={() => setToggleCancelAccountWindow(false)}>No</button>
                        </div>
                    </>
                        :
                        <>
                            <p className={styles.cancelTitle}>{message}</p>
                            <p className={styles.cancelTitle}>{error}</p>
                            {!error && < p className={styles.cancelParagraph}>You will shortly receive confirmation by email​</p>}
                            <div className={styles.dissmissButtonContainer}>
                                <button className={styles.cancelButton} onClick={closeCancelWindow}>Close</button>
                            </div>
                        </>
                    }
                </div>
            }
            <h2 className={styles.dashboardHeader}>Your Dashboard</h2>
            <div className={styles.accountContainer}>
                {togglePopup &&
                    <FeaturePoup closePopup={toggleInfoPopup} />
                }
                <h3 className={styles.sectionTitle}>Account information</h3>
                <div className={styles.userDataContainer}>
                    <div>
                        <p>Email address:</p>
                        <p className={styles.userData}>{currentUser.email}</p>
                    </div>
                    <div className={styles.subscriptionContainer}>
                        <p>Subscription:</p>
                        <div className={styles.subscriptionData}>
                            <p className={styles.userData}>{statusData && statusData.isPaid ? 'Device Tracker Plus' : 'Unsubscribed'} </p>
                            <img src={infoIcon} alt="info_icon" width={20} className={styles.infoIcon} onClick={toggleInfoPopup} />
                            <p className={styles.stausCanceled}>{statusData && statusData.cancelledDate ? 'Canceled' : ''}</p>
                        </div>
                    </div>

                </div>
            </div>
            <br />
            <div className={styles.accountContainer}>
                <h3 className={styles.sectionTitle}>Billing information - last 12 months</h3>
                <div className={styles.invoiceGrid}>

                    {dashboardData?.invoices.map((item, index) => (
                        <div className={styles.invoiceData} key={index}>
                            <a href={item.invoicePdf} download><img src={downLoadIcon} alt="downLoad_icon" width={20} style={{ marginRight: '10px' }} /></a>
                            <p className={styles.invoiceTitle}>{item.name}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.dashboardButtonsContainer}>
                <div className={styles.buttonContainer} style={{ marginTop: '20px' }}>
                </div>
                <div className={styles.buttonContainer}>
                    <a href={'/help'} className={styles.dashboardButton}>Contact support</a>
                    &nbsp;
                    <button onClick={showCancelPopup} className={styles.dashboardButton}>
                        Cancel account
                    </button>
                    &nbsp;
                    <button onClick={handleLogout} className={styles.dashboardButton}>
                        Log Out
                    </button>
                </div>
            </div>
        </div >
    );
}